import { render } from "./Land.vue?vue&type=template&id=32a667ce"
import script from "./Land.vue?vue&type=script&lang=js"
export * from "./Land.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__